import React from "react";
import { Popover, Typography, Box } from "../../../common/MuiImports";

interface InfoPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  content: string;
}

const InfoPopover: React.FC<InfoPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  content,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      sx={{
        "& .MuiPopover-paper": {
          maxWidth: 300,
          p: 2,
          mt: 1,
        },
      }}
      data-test-id="selfcare-info-popover"
    >
      <Box sx={{ p: 1 }} data-test-id="selfcare-info-popover-content-box">
        <Typography
          variant="body2"
          gutterBottom
          data-test-id="selfcare-info-popover-text"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Box>
    </Popover>
  );
};

export default InfoPopover;
